module.exports = __webpack_public_path__ + "img/index_glzx2.d640a411.png";